<div *ngIf="shouldShowLoginUI" class="container py-5">
  <div class="row">
    <div class="col-md-12">
      <div class="logo-container text-center mb-4">
        <img src="assets/logo.png" alt="Inpress Logo" class="login-logo" />
      </div>

      <div class="row">
        <div class="col-md-6 mx-auto">
          <!-- form card login -->
          <div class="card rounded-0">
            <div class="card-header"><h3 class="mb-0">Login</h3></div>

            <div class="card-body">
              <form
                [formGroup]="loginForm"
                class="form"
                role="form"
                autocomplete="off"
                id="formLogin"
                novalidate=""
                (submit)="login()"
              >
                <div class="form-container">
                  <mat-form-field appearance="outline">
                    <mat-label>E-mail</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="login"
                      placeholder="E-mail"
                      required
                      email
                    />
                    <mat-error>E-mail is vereist</mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>Wachtwoord</mat-label>
                    <input
                      matInput
                      type="password"
                      formControlName="password"
                      placeholder="Wachtwoord"
                      required
                    />
                    <mat-error>Wachtwoord vereist</mat-error>
                  </mat-form-field>
                </div>
                <mat-checkbox
                  formControlName="persist"
                  class="custom-control-description small text-dark"
                  >Ingelogd blijven</mat-checkbox
                >

                <button
                  type="submit"
                  class="btn btn-success btn-lg float-right"
                  id="btnLogin"
                >
                  Login
                </button>
              </form>
              <div class="form-field">
                <a class="small" routerLink="/request-account-recovery"
                  >Wachtwoord vergeten?</a
                >
                <br />
                <a
                  class="secondary-color strong"
                  routerLink="/request-new-account"
                  >Nog geen account? Start hier</a
                >
              </div>
            </div>
            <!--/card-block-->
          </div>
          <!-- /form card login -->
        </div>
      </div>
      <!--/row-->
    </div>
    <!--/col-->
  </div>
  <!--/row-->
</div>
